"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
exports.ShiftAPI = {
    getShifts: function (companyId, deviceId, pagination) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/shifts?", {
            params: __assign({ deviceId: deviceId }, pagination)
        })
            .then(function (response) {
            var shifts = response.data;
            return shifts;
        });
    },
    getShiftById: function (companyId, shiftId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/shift/" + shiftId).then(function (response) {
            var shift = response.data;
            return shift;
        });
    },
    getCurrentShift: function (companyId, deviceId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/shifts/current").then(function (response) {
            var shift = response.data.shift;
            return shift;
        });
    },
    addShift: function (companyId, deviceId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/shifts", createObject)
            .then(function (response) {
            var shift = response.data;
            return shift;
        });
    },
    endShift: function (companyId, deviceId, endObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/shifts/end", endObject)
            .then(function (response) {
            var shift = response.data;
            return shift;
        });
    },
    updateCashCount: function (companyId, deviceId, shiftId, cashCountUpdateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/shifts/" + shiftId + "/cashCount", cashCountUpdateObject);
    },
    updateShiftCash: function (companyId, shiftId, registerPasscode, mode, amount, notes) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/shift/" + shiftId + "/cash", {
            mode: mode,
            registerPasscode: registerPasscode,
            amount: amount,
            notes: notes
        });
    },
    trackHoursWithPasscode: function (companyId, deviceId, passcode) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/clockIn", {
            registerPasscode: passcode
        }).then(function (response) {
            var user = response.data;
            return user;
        });
    },
    trackHoursWithEmployeeId: function (companyId, deviceId, employeeId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/clockIn", {
            employeeId: employeeId
        }).then(function (response) {
            var user = response.data;
            return user;
        });
    },
    startBreakWithPasscode: function (companyId, deviceId, passcode) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/startBreak", {
            registerPasscode: passcode
        }).then(function (response) {
            var user = response.data;
            return user;
        });
    },
    clearCurrentShiftUser: function (companyId, shiftId) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/shifts/" + shiftId + "/clearCurrentUser")
            .then(function (response) {
            var shift = response.data;
            return shift;
        });
    },
    stopTrackingHours: function (companyId, deviceId, passcode) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/user/device/" + deviceId + "/clockOut", {
            registerPasscode: passcode
        }).then(function (response) {
            return;
        });
    }
};
//# sourceMappingURL=ShiftAPI.js.map